export default __webpack_public_path__ + "static/media/pantry1-afterF-480w.6e19dd97.webp";